/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IHoundOwner, IHoundOwnerInterface } from "../IHoundOwner";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "houndOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IHoundOwner__factory {
  static readonly abi = _abi;
  static createInterface(): IHoundOwnerInterface {
    return new utils.Interface(_abi) as IHoundOwnerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IHoundOwner {
    return new Contract(address, _abi, signerOrProvider) as IHoundOwner;
  }
}
